export default {
  apiPoint: 'post'
};
